export default __webpack_public_path__ + "static/media/pegasus-airlines-eps-vector-logo.6fa0e9ba.png";